import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/lukas/Sites/git/own-packages/react-i18n-kit/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from "docz";
import { Translator, DynamicTextHoc as DynamicText } from "./components";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Translator heading page="dynamicApproachHoc" num="0" mdxType="Translator" />
    <Translator page="dynamicApproachHoc" num="0" mdxType="Translator" />
    <Translator page="dynamicApproachHoc" num="1" mdxType="Translator" />
    <Translator page="dynamicApproachHoc" num="2" mdxType="Translator" />
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// './i18n/index.js'
const data = {
  de: {
    text: "Hallo Welt!",
  },
  en: {
    text: "Hello World!",
  },
  es: {
    text: "!Hola Mundo!",
  },
};

export { data };
`}</code></pre>
    <Translator page="dynamicApproachHoc" num="3" mdxType="Translator" />
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React from "react";
import { withI18n } from "../../../src";

import { data } from "./i18n";

const DynamicText = props => (
  <>
    <button type="submit" onClick={() => props.translate("en")}>
      English
    </button>
    <button type="submit" onClick={() => props.translate("es")}>
      Español
    </button>
    <button type="submit" onClick={() => props.translate("de")}>
      Deutsch
    </button>
    <div>{props.i18n.text}</div>
  </>
);

const DynamicTextWithI18n = withI18n(DynamicText, data);

export { DynamicTextWithI18n as DynamicText };
`}</code></pre>
    <Translator page="dynamicApproachHoc" num="4" mdxType="Translator" />
    <Playground __position={6} __code={'<DynamicText lang=\"en\" />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Translator,
      DynamicText
    }} mdxType="Playground">
  <DynamicText lang="en" mdxType="DynamicText" />
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      